function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q4Man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M431.1,148.8c0-16.7-3.7-61.7-5.8-82.2c-2.1-21.9-4.2-46.5-27.2-46.5c-23,0-25.6,25.7-27.5,47.9 c-1.8,20.3-5.5,66.7-5.5,80.8C365.1,168.9,431.1,168.9,431.1,148.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M383.7,162.5c0,0,6.5,9.2,15.4,8.1c15-1.9,15.4-8.5,15.4-8.5"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 400.2,
  y1: 192.6,
  x2: 399.9,
  y2: 170.7
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M406.8,200.5l-22.9-0.3c0,0,9.6-8.9,18-7.5C410.3,194.1,406.8,200.5,406.8,200.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M369.3,84.8c-0.7,0.2-1.1-0.6-0.6-1c4.3-3.2,12.8-8.3,26.8-12.9c19.4-6.3,35.7-7.6,39.8-7.8 c0.5,0,0.8,0.4,0.6,0.9l-8.2,17.6c-0.1,0.2-0.3,0.4-0.6,0.3C422.9,81.6,386.1,78.8,369.3,84.8z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st3",
  cx: 397.5,
  cy: 99.9,
  rx: 12.3,
  ry: 15.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M369.1,84.9c-1.4,17.6-3.1,40-3.7,54.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M375.9,83.3c-1.4,17.6-2.7,34.4-3.4,48.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M381.6,83.3c-1.4,17.6-2.7,34.4-3.4,48.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M365.5,138.9l-6.2,19c0,0,28.7,14.1,56.7,6c15.8-4.6,23-9.3,23-9.3l-8.6-15.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M387,140.5c0,0-4.6,6.1-25.6,11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M382.7,140.4c-3.8,2.1-10.1,4.8-20.2,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M430.8,138.9c-0.7-15.5-2.5-39-4.1-57"
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 377.9,
  y1: 148.2,
  x2: 377,
  y2: 152.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M361.4,154c7,3,31.1,11.9,54.7,5.1c10-2.9,16.6-5.9,20.1-7.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M375,162.2L375,162.2c-2-0.4-3.2-2.4-2.8-4.3l0.6-2.9c0.4-2,2.4-3.2,4.3-2.8h0c2,0.4,3.2,2.4,2.8,4.3 l-0.6,2.9C378.9,161.3,376.9,162.6,375,162.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M372.9,154.5c0,0,1.9,1.6,3.1,1.9s3.9,0,3.9,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M372.2,157.8c0,0,1.9,1.6,3.1,1.9s3.9,0,3.9,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M423.8,138.1c0,0,2,5.1-11.7,9.2c-2.1,0.6-4.5,1.2-7.4,1.8c-21.7,4.2-34.6-11.3-34.6-11.3l-2.9,1.9 c0,0,14.2,18,38.3,13.1c3.2-0.6,5.9-1.3,8.2-2.1c15.2-4.7,12.9-10.7,12.9-10.7L423.8,138.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M432.1,137.3c-1.3,2.4-11.9,2.5-23.5,3.1c-11.6,0.6-47.9-0.7-47.9-0.7l1.9-8.8c0,0,34.1,1.2,45.4,0 c5.9-0.6,24.1-2.4,24.1-2.4V137.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M432.1,133.2c-25.6,5.7-64.9,2.2-64.9,2.2l1-4.4"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st4",
  cx: 397.5,
  cy: 99.9,
  rx: 15.6,
  ry: 19.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M421.5,81c0.2,17.7,2.2,34.2,2.9,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M415.8,81c0.2,17.7,2.2,34.2,2.9,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M409.9,112c0.5,6.4,1,12.6,1.3,18.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M403.7,117.8c0.3,4.3,0.6,8.5,0.8,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M397.2,119.7c0,4.4,0,8.5-0.1,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M391.6,118.5c0,4.4,0,8.5-0.1,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M386.3,113.8c-0.5,4-0.6,11.5,0,16.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M428.3,64.5c0,0-6.6,6.6-6.7,17.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M418.3,65.2c0,0-4.2,8-3.3,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M407.6,67.4c0,0-3,11-1.1,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M395.6,70.9c0,0-3.1,6.7-0.7,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M384.8,74.9c0,0-2,4.8,0.4,6.8"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st9",
  cx: 376.5,
  cy: 59.4,
  r: 1.7
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M371.3,68.5c8.4,0,13.9,5.7,15.8,1.4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q4TelescopeGroup"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st11",
  x1: 316.3,
  y1: 198.4,
  x2: 316.3,
  y2: 85.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st11",
  x1: 283.3,
  y1: 198.4,
  x2: 316.3,
  y2: 85.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st11",
  x1: 349.3,
  y1: 198.4,
  x2: 316.3,
  y2: 85.2
}), /*#__PURE__*/React.createElement("g", {
  id: "Q4Telescope"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 316.3,
  cy: 86.4,
  r: 7.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 316.3,
  cy: 86.4,
  r: 2.9
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "262.7,38.3 283.3,40.2 283.3,66 262.7,67.9  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 278.7,
  y1: 39.8,
  x2: 278.7,
  y2: 67.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 319.7,
  y1: 43.9,
  x2: 319.7,
  y2: 61.6
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "323.7,61.5 283.3,62.9 283.3,43 323.7,44.4  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 345,
  y1: 47.7,
  x2: 345,
  y2: 57.9
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "349.1,57.8 323.7,58.6 323.7,47.2 349.1,48  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 349.1,
  y: 50.9,
  className: "st15",
  width: 8.9,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 356.7,
  y: 50.9,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 412.7676 -307.062)",
  className: "st15",
  width: 6.5,
  height: 3.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M262.7,66.9c-4.3,0-7.8-6.2-7.8-13.8s3.5-13.8,7.8-13.8"
}), /*#__PURE__*/React.createElement("line", {
  className: "st13",
  x1: 314,
  y1: 79.2,
  x2: 318.6,
  y2: 61.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st13",
  x1: 319.7,
  y1: 79.2,
  x2: 325.1,
  y2: 58.6
})))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q4FrogGroup"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q4Frog"
}, /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M277.4,129.3c1.4-2.1,8.2-4.3,10.7-0.8c2.5,3.4,0,8.1,0.4,8.8c0.5,0.7,7.1-0.8,7.7,0.5 c0.6,1.3,0.8,4.7,0.8,4.7h-20.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M269.9,142.5c0,0-2.6-8.2,3.9-18s20.2-15.4,26.6-14.1s1.6-7.6,10.3-7.2c8.1,0.3,6.6,8.1,8.1,9 s9.3,7.6,9.5,20.4c0.1,3-2.7,3.8-6.4,4.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M269.9,141.5c0,0-2.4,0.7-5.7-1.4s-6.8-0.9-6.8-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M313.1,111.1c0,0-1.2,1-2.8,1s-2.8-1-2.8-1s1.2-1,2.8-1S313.1,111.1,313.1,111.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M303.6,135.2c0,0,14.4,0.3,17.5,1.6c3.1,1.3,3.8,5.7,3.8,5.7h-21.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M282.3,121c0,0,7-5.9,13.4-6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M284.9,122.6c1.7-1.3,5.5-3.9,9.6-5.2"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st18",
  cx: 310.3,
  cy: 111.1,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M271.2,129.4c0,0-5-11.7,4.8-19.2s20.3,0.1,20.3,0.1"
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 281.6,
  y1: 116.3,
  x2: 274.9,
  y2: 108.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 286.1,
  y1: 113.9,
  x2: 282.9,
  y2: 105.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 277.9,
  y1: 119.8,
  x2: 269.8,
  y2: 114.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 274.5,
  y1: 123.6,
  x2: 268.5,
  y2: 121.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 291.3,
  y1: 111.5,
  x2: 290.8,
  y2: 106.2
})), /*#__PURE__*/React.createElement("rect", {
  x: 263.1,
  y: 154.9,
  className: "st20",
  width: 67.8,
  height: 43.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 257,
  y: 145.5,
  className: "st20",
  width: 79.9,
  height: 9.5
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q4EyeMask"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M423,45.4l-51.9,3.2c-1.2,0.1-2.2,1-2.3,2.2L367.5,63c-0.2,1.7,1.3,3.1,3,2.7l53.4-12 c0.9-0.2,1.7-0.9,1.9-1.8c0.2-0.7,0.3-1.5,0.3-2.3c0-0.8-0.3-1.8-0.6-2.6C425.1,45.9,424.1,45.3,423,45.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M426.1,49.5c4.4,0,18.2,3,18.2,9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M424,52.5c2.9-3.2,14.5-11.4,18.9-7.4"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st24",
  cx: 423.2,
  cy: 49.5,
  r: 4.9
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q4HandGroup"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Q4Sward"
}, /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M355.8,4l3.5,0l-0.8,95L348.1,99l0.8-88.1C348.9,7.1,352,4,355.8,4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M358.5,99l0.8-88.4c-3.4,1.7-5.8,5.2-5.8,9.3l-0.7,79L358.5,99z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 347.7,
  y: 99.2,
  transform: "matrix(-1 -8.014702e-03 8.014702e-03 -1 705.6213 207.7537)",
  className: "st21",
  width: 11.1,
  height: 6.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M351.7,133.4l2.5,0c1.3,0,2.5-1.1,2.5-2.4l0.2-21.4c0-0.3-0.3-0.6-0.6-0.6l-6.2,0c-0.3,0-0.6,0.3-0.6,0.6 l-0.2,21.4C349.2,132.2,350.3,133.3,351.7,133.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 334.9,
  y: 105.5,
  transform: "matrix(-1 -8.014702e-03 8.014702e-03 -1 705.043 217.4458)",
  className: "st22",
  width: 36,
  height: 3.7
})), /*#__PURE__*/React.createElement("path", {
  id: "Q4Hand",
  className: "st23",
  d: "M348,120.7c-1.6-0.4-2.7-1.8-2.7-3.5c0-1.9,1.6-3.5,3.6-3.4l33.4,0.4c1.4,0,2.8-0.7,3.6-1.8 L396,98.1c1.1-1.6,3.3-1.9,4.9-0.8c1.6,1.1,1.9,3.3,0.8,4.9l-10.2,14.3c-2.2,3-5.7,4.8-9.4,4.7l-33.4-0.4 C348.4,120.8,348.2,120.8,348,120.7z"
})));

var SvgQ4Svg = function SvgQ4Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q4svg",
    x: "0px",
    y: "0px",
    width: "714.5px",
    height: "202px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ4Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q4svg.c588ce5e.svg";
export { ForwardRef as ReactComponent };